// eslint-disable-next-line no-unused-vars
import React from 'react';
import { ToggleContainer, Form } from '@weezevent/nacre';

export default function ToggleInput({ label, description, value, onChange = () => {}, ...params }) {
    return (
        <Form.Field>
            <ToggleContainer
                title={label}
                subtitle={description}
                toggle={value}
                onToggle={checked => {
                    onChange(checked);
                }}
                {...params}
            />
        </Form.Field>
    );
}
